import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  get_NullableIntAdapter1poaa869odci7 as get_NullableIntAdapter,
  get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter,
  nullable1in0t8o94jx9t as nullable,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_getInstance313brsqqgys0x as Companion_getInstance } from '../GraphQLFloat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from '../SavePartyInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyInput_InputAdapterClass;
function SavePartyInput_InputAdapter() {
  if (SavePartyInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      i75(writer, customScalarAdapters, value) {
        writer.k4e('partyId');
        get_partyIdAdapter().t41(writer, customScalarAdapters, value.k73_1);
        var tmp = value.l73_1;
        if (tmp instanceof Present()) {
          writer.k4e('name');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.l73_1);
        }
        var tmp_0 = value.m73_1;
        if (tmp_0 instanceof Present()) {
          writer.k4e('email');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.m73_1);
        }
        var tmp_1 = value.n73_1;
        if (tmp_1 instanceof Present()) {
          writer.k4e('pairingRule');
          present(get_NullableIntAdapter()).r42(writer, customScalarAdapters, value.n73_1);
        }
        var tmp_2 = value.o73_1;
        if (tmp_2 instanceof Present()) {
          writer.k4e('badgesEnabled');
          present(get_NullableBooleanAdapter()).r42(writer, customScalarAdapters, value.o73_1);
        }
        var tmp_3 = value.p73_1;
        if (tmp_3 instanceof Present()) {
          writer.k4e('defaultBadgeName');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.p73_1);
        }
        var tmp_4 = value.q73_1;
        if (tmp_4 instanceof Present()) {
          writer.k4e('alternateBadgeName');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.q73_1);
        }
        var tmp_5 = value.r73_1;
        if (tmp_5 instanceof Present()) {
          writer.k4e('callSignsEnabled');
          present(get_NullableBooleanAdapter()).r42(writer, customScalarAdapters, value.r73_1);
        }
        var tmp_6 = value.s73_1;
        if (tmp_6 instanceof Present()) {
          writer.k4e('animationsEnabled');
          present(get_NullableBooleanAdapter()).r42(writer, customScalarAdapters, value.s73_1);
        }
        var tmp_7 = value.t73_1;
        if (tmp_7 instanceof Present()) {
          writer.k4e('animationSpeed');
          present(nullable(customScalarAdapters.p49(Companion_getInstance().e6y_1))).r42(writer, customScalarAdapters, value.t73_1);
        }
      }
      t41(writer, customScalarAdapters, value) {
        return this.i75(writer, customScalarAdapters, value instanceof SavePartyInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePartyInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePartyInput_InputAdapterClass = $;
  }
  return SavePartyInput_InputAdapterClass;
}
var SavePartyInput_InputAdapter_instance;
function SavePartyInput_InputAdapter_getInstance() {
  return SavePartyInput_InputAdapter_instance;
}
//region block: init
SavePartyInput_InputAdapter_instance = new (SavePartyInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePartyInput_InputAdapter_instance as SavePartyInput_InputAdapter_instanceergmyw6zfzfp,
};
//endregion

//# sourceMappingURL=SavePartyInput_InputAdapter.mjs.map
